const module = {
  config: {
    name: "Users Old",
    icon: 'user-search',
    desc: "User list",
    layout: true,
    order: 8
  },
  routes: [
    {
      name: 'User Credentials',
      icon: 'user-settings',
      path: '/user-credentials',
      translate_key: 'user_credentials',
      component: () => import('./users/users.vue'),
      separator: 'CREDENTIALS'
    },
    {
      name: 'App Access',
      icon: 'shield-keyhole',
      path: '/app-access',
      translate_key: 'app_access',
      component: () => import('./users/usersApp.vue'),
    },
    {
      name: 'Donor',
      icon: 'user-shared',
      path: '/donor',
      translate_key: 'donor',
      component: () => import('./customer/donor/donor.vue'),
      separator: 'PUBLIC'
    },
    {
      name: 'Sponsor',
      icon: 'user-shared',
      path: '/sponsor',
      translate_key: 'sponsor',
      component: () => import('./customer/sponsor/sponsor.vue')
    },
    {
      name: 'Participant',
      icon: 'user-shared',
      path: '/participant',
      translate_key: 'participant',
      component: () => import('./customer/participant/participant.vue'),
    },
    {
      name: 'Corporate',
      icon: 'building',
      path: '/corporate',
      translate_key: 'corporate',
      component: () => import('./corporate/corporate.vue'),
    },
   
  ]
};
export default module;



// WEBPACK FOOTER //
// ./src/modules/users-old/_index.js